import { Text } from '@/components/ui/Text';
import type { Member } from '../../../types';
import { PlanIcon } from '../../shared';

export function QuoteMemberLineItem({
  member,
  price,
}: {
  member: Member;
  price: number | null;
}) {
  return (
    <div>
      <div className='flex items-center gap-2 py-4 md:gap-4 lg:mx-auto lg:max-w-[1400px] lg:gap-5'>
        <div className='hidden lg:block'>
          <PlanIcon plan={member.plan ?? 'Signature'} size='lg' />
        </div>
        <div className='lg:hidden'>
          <PlanIcon plan={member.plan ?? 'Signature'} />
        </div>

        {/* Member info */}
        <div className='flex-1'>
          <div className='flex items-center'>
            <Text variant='h3' className='hidden items-center gap-1 md:flex'>
              {member.first_name} {member.last_name}
            </Text>
            <Text
              variant='body'
              bold
              className='flex items-center gap-1 md:hidden'
            >
              {member.first_name} {member.last_name}
            </Text>
          </div>
          <Text variant='body' color='dark'>
            Sollis {member.plan}
            {member.plan !== 'Pediatrics' &&
              member.pediatrics_enabled &&
              ' + Pediatrics'}
          </Text>
          {/* Price - mobile only */}
          <Text variant='body' color='dark' className='md:hidden'>
            {price !== null ? `$${price.toLocaleString()}` : '\u2014'}
          </Text>
        </div>

        {/* Price - desktop only */}
        <Text variant='h3' className='flex hidden items-center md:block'>
          {price !== null ? `$${price.toLocaleString()}` : '\u2014'}
        </Text>
      </div>

      {/* Divider */}
      <div className='bg-sh-dark-gray h-px' />
    </div>
  );
}
